export const CLOSED_CONCILIATION_REPORT = "closedConciliations"
export const CLOSED_CONCILIATION_COUNT_REPORT = "closedConciliationCount"
export const LACK_REPORT = "lack"
export const DAY_LACK_REPORT = "daylack"
export const OPEN_CONCILIATION_COUNT_REPORT = "openConciliationCount"